module.exports = __webpack_public_path__ + "assets/close-circle-filled-5c6ce0.svg";